import cn from "classnames";
import type {Argument} from "classnames";

export const getClassNames = (...args: Argument[]) => {
  return cn(args);
};